import { SKIPPED } from '@datadog/browser-core';
import { RumEventType } from '@datadog/browser-rum-core';
export function startProfilingContext(hooks) {
    let currentContext = {
        status: 'starting',
    };
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        if (eventType !== RumEventType.VIEW &&
            eventType !== RumEventType.LONG_TASK &&
            eventType !== RumEventType.ACTION &&
            eventType !== RumEventType.VITAL) {
            return SKIPPED;
        }
        return {
            type: eventType,
            _dd: {
                profiling: currentContext,
            },
        };
    });
    return {
        get: () => currentContext,
        set: (newContext) => {
            currentContext = newContext;
        },
    };
}
//# sourceMappingURL=profilingContext.js.map